import Vue from 'vue';

// Plugins
import Paginate from 'vuejs-paginate';
import money from 'v-money';
import FloatingVue from 'floating-vue';

// Shared components
import { Icon, Hint, ActionButton, ActionLink, Spinner } from 'fourwaves-shared/components';

// Layout
import SidePanel from '~/components/layout/SidePanel.vue';

// Form components
import Geocomplete from '~/components/form/Geocomplete.vue';
import RichTextEditor from '~/components/form/RichTextEditor.vue';
import ChangeDetectionBox from '~/components/form/ChangeDetectionBox.vue';

Vue.component('Paginate', Paginate);
Vue.use(money, { precision: 2 });
Vue.use(FloatingVue);
Vue.component('Spinner', Spinner);
Vue.component('Icon', Icon);
Vue.component('Hint', Hint);
Vue.component('SidePanel', SidePanel);
Vue.component('Geocomplete', Geocomplete);
Vue.component('RichTextEditor', RichTextEditor);
Vue.component('ChangeDetectionBox', ChangeDetectionBox);

Vue.component('ActionLink', ActionLink);
Vue.component('ActionButton', ActionButton);
